import { Routes } from '@angular/router';
import { BootstrapMembersTabsComponent } from './bootstrap-members-tabs/bootstrap-members-tabs.component';
const ɵ0 = () => import("./continental-member-information/continental-member-information.module.ngfactory").then(m => m.ContinentalMemberInformationModuleNgFactory), ɵ1 = () => import("./members-information/members-information.module.ngfactory").then(m => m.MembersInformationModuleNgFactory), ɵ2 = () => import("./members-information/members-information.module.ngfactory").then(m => m.MembersInformationModuleNgFactory), ɵ3 = () => import("./members-events/members-events.module.ngfactory").then(m => m.MembersEventsModuleNgFactory), ɵ4 = () => import("./members-athletes/members-athletes.module.ngfactory").then(m => m.MembersAthletesModuleNgFactory), ɵ5 = () => import("./member-news/member-news.module.ngfactory").then(m => m.MemberNewsModuleNgFactory);
const routes = [
    {
        path: '', children: [
            {
                path: 'detail/association/:noc/:fedname', loadChildren: ɵ0
            },
            {
                path: ':noc', loadChildren: ɵ1
            },
            {
                path: ':noc/:fedname', loadChildren: ɵ2
            },
            { path: ':noc/:fedname/events', loadChildren: ɵ3 },
            { path: ':noc/:fedname/athletes', loadChildren: ɵ4 },
            { path: ':noc/:fedname/news', loadChildren: ɵ5 }
        ], component: BootstrapMembersTabsComponent
    }
];
export class DetailsPageRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
